import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import { AuthState, CustomUserClaims, UserClaims } from '@okta/okta-auth-js';
import { filter, map, Observable } from 'rxjs';
import { GroupLinkService } from '../services/group-link.service';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  patron: UserClaims<CustomUserClaims>;
  name$!: Observable<string>;
  isAuthenticated$!: Observable<boolean>;
  isGuestSelected: boolean;
  checkedUser: boolean;
  creatingAcc: boolean;
  validUser: boolean;
  transactionId: number | string;

  private router = inject(Router);
  private groupLinkService = inject(GroupLinkService);
  private _oktaAuth = inject(OKTA_AUTH);
  private _oktaAuthStateService = inject(OktaAuthStateService);
  private _oktaStateService = inject(OktaAuthStateService);

  constructor() {}

  ngOnInit(): void {
    this.isAuthenticated$ = this._oktaStateService.authState$.pipe(
      filter((s: AuthState) => !!s),
      map((s: AuthState) => s.isAuthenticated ?? false)
    );

    this.name$ = this._oktaAuthStateService.authState$.pipe(
      filter(
        (authState: AuthState) => !!authState && !!authState.isAuthenticated
      ),
      map((authState: AuthState) => authState.idToken?.claims.name ?? '')
    );
  }

  async showPatron(): Promise<void> {
    this.patron = await this._oktaAuth.getUser();
  }

  async signOut(): Promise<void> {
    await this._oktaAuth.signOut();
  }

  findTDCAcc() {
    this.checkedUser = true;
  }

  createTDCAcc() {
    this.creatingAcc = true;
    this.validUser = true;
  }

  goTo(goPage: string) {
    this.router.navigate(
      this.groupLinkService.prependGroupLink(['/', goPage, this.transactionId])
    );
  }

  backTo(backPage: string) {
    this.router.navigate(
      this.groupLinkService.prependGroupLink(['/', backPage])
    );
  }

  switchLoginMethod() {
    this.isGuestSelected = !this.isGuestSelected;
  }
}
